<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 订单管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>采购订单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">		
				<div>
					<el-select v-model="query.orderCompanyId" placeholder="请选择公司" filterable>
						<el-option key="" label="请选择公司" value=""></el-option>
						<el-option v-for="item in channelsKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>&nbsp;
					<el-input v-model="query.productName" placeholder="产品型号" class="handle-input mr10" style ="width:200px;"></el-input>
					<el-select v-model="query.arrivalStatus" placeholder="请选择到货状态">
						<el-option key="" label="请选择到货状态" value=""></el-option>
						<el-option key="0" label="未到货" value="0"></el-option>
						<el-option key="1" label="部分到货" value="1"></el-option>
						<el-option key="2" label="全部到货" value="2"></el-option>
					</el-select>
					&nbsp;
					<el-select v-model="query.payType" placeholder="请选择支付类型">
						<el-option key="" label="请选择支付类型" value=""></el-option>
						<el-option key="0" label="实时支付" value="0"></el-option>
						<el-option key="1" label="快递代收" value="1"></el-option>
						<el-option key="2" label="账期付款" value="2"></el-option>
					</el-select>
					&nbsp;
					<el-select v-model="query.invoiceStatus" placeholder="请选择发票状态">
						<el-option key="" label="请选择发票状态" value=""></el-option>
						<el-option key=null label="不含税" value=null v-if="companyConfig.showNoTax"></el-option>
						<el-option key=false label="未开票" value=false></el-option>
						<el-option key=true label="已开票" value=true></el-option>
					</el-select>
				</div>
				<div style="padding-top : 20px">
					<el-select v-model="query.status" placeholder="请选择订单状态">
						<el-option key="" label="请选择订单状态" value=""></el-option>
						<el-option key="0" label="待审核" value="0"></el-option>
						<el-option key="1" label="待付款" value="1"></el-option>
						<el-option key="2" label="待收货" value="2"></el-option>
						<el-option key="3" label="收货中" value="3"></el-option>
						<el-option key="4" label="已收货" value="4"></el-option>
						<el-option key="5" label="已完结" value="5"></el-option>
						<el-option key="6" label="已撤销" value="6"></el-option>
					</el-select>&nbsp;
					<el-date-picker
						type="datetime"
						placeholder="开始时间"
						v-model="query.createTimeStart"
						value-format="yyyy-MM-dd HH:mm:SS"
					></el-date-picker> &nbsp;
					<el-date-picker
						type="datetime"
						placeholder="结束时间"
						v-model="query.createTimeEnd"
						value-format="yyyy-MM-dd HH:mm:SS"
					></el-date-picker>&nbsp;
					<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
					<el-button type="primary" icon="el-icon-odometer" @click="lookupProductDeficiencyStatus">待订购产品检索</el-button>
				</div>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				@current-change="handleCurrentChange"
				highlight-current-row
				stripe
            >
				<el-table-column prop="orderNo" label="订单号" width="130"></el-table-column>
				<el-table-column prop="orderCompanyName" label="供货公司"></el-table-column>
                <el-table-column prop="operator" label="经办人" width="90"></el-table-column>
				<el-table-column prop="total" label="数量" width="60"></el-table-column>
				<el-table-column prop="amount" label="金额" width="90"><template slot-scope="scope">￥{{scope.row.amount}}</template></el-table-column>
				<el-table-column prop="payType" label="付款方式" :formatter="payTypeFormat" width="100">
					<template slot-scope="scope" v-if="scope.row.status<6">
					<el-tag :type= "(scope.row.payReceipt > '' || scope.row.balancePayment > 0)?'success':((scope.row.payType===2 && new Date(scope.row.payTime).getTime() < new Date().getTime())?'danger':'warning')" >{{payTypeFormat(null, null, scope.row.payType)}}
					</el-tag>
					</template>
				</el-table-column>
				</el-table-column>
				<el-table-column prop="arrivalStatus" label="到货状态" :formatter="arrivalStatusFormat" width="100"></el-table-column>
				<el-table-column prop="invoiceStatus" label="是否开票" width="90">
					<template slot-scope="scope" v-if="scope.row.status<6">
						<el-tag :type= "scope.row.taxIncluded?(scope.row.invoiceStatus?'success':'warning'):'info'" >{{scope.row.taxIncluded?(scope.row.invoiceStatus?'已开票':'未开票'):'无票'}} </el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="订单状态" :formatter="statusFormat" width="80"></el-table-column>
				<el-table-column prop="createTime" label="下单时间" width="160"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show'] && scope.row.status > 0"
                        >详情</el-button>
						<el-button
                            type="text"
                            icon="el-icon-edit-outline"
                            @click="handleCheck(scope.$index, scope.row)"
							v-if="controll['check'] && scope.row.status === 0"
                        >审核</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit'] && scope.row.status === 0"
                        >编辑</el-button>
						<el-button
                            type="text"
                            icon="el-icon-sold-out"
                            @click="hanleArrival(scope.$index, scope.row)"
							v-if="controll['arrival'] && (scope.row.status > 1 && scope.row.status < 4)"
                        >收货</el-button>
						<el-button
                            type="text"
                            icon="el-icon-mobile-phone"
                            @click="handlePaid(scope.$index, scope.row)"
							v-if="controll['paid'] && (scope.row.status > 0 && scope.row.status != 6 && scope.row.realPayTime == undefined)"
                        >支付</el-button>
						<el-button
                            type="text"
                            icon="el-icon-news"
                            @click="hanleCancel(scope.$index, scope.row)"
							v-if="controll['cancel'] && scope.row.status <= 2"
                        >撤销</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<!--<el-button
					style="float:left"
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >新增采购</el-button>-->
				<el-dropdown 
					style="float:left;margin-right:10px;"
					icon="el-icon-lx-add"
					split-button 
					type="primary" 
					v-if="controll['add']" 
					@click="handleAdd"
					@command="handleCommand">
					<i class="el-icon-lx-add"></i> 新增采购
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="add">新增订单</el-dropdown-item>
						<el-dropdown-item command="copy">复制订单</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-upload
					style="float:left"
					class="upload-demo mr10"
					:show-file-list="false"
					accept=".pdf,.jpg,.png"
					:action= "contractUploadUrl"
					:before-upload="contractUploadStart"
					:on-success="contractUploadSuccess"
					:file-list="contractFileList"
					list-type="picture"
				>
					<el-button size="small" icon = "el-icon-folder-opened" type="primary">导入采购合同订单</el-button>
				</el-upload>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		
		<!-- 显示待订购产品 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="待订货产品型号" :visible.sync="productDeficiencyVisible" width="50%">
			<el-table
				:data="productDeficiencyData"
				border
				class="table"
				header-cell-class-name="table-header"
				:cell-style="{padding:1+'px'}"
				stripe
			>
				<el-table-column prop="id" label="序号" width="80">
					<template slot-scope="scope">
						{{scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column prop="brand" label="品牌" width="150"></el-table-column>
				<el-table-column prop="seriesName" label="名称" width="250"></el-table-column>
				<el-table-column prop="productName" label="型号" width="150"></el-table-column>
				<el-table-column prop="deficiencyNum" label="缺少数量"></el-table-column>
			</el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="productDeficiencyVisible=false">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="65%" :before-close="cancelEdit">
			<el-tabs v-model="activeName" type="card">
				<el-tab-pane label="订单基本信息" name="baseTab">
					<el-form ref="form" :model="form" label-width="100px" :rules="rules">
						<el-row>
							<el-col :span="12">
								<el-form-item label="供货公司" prop="orderCompanyId">
									<el-select v-model="form.orderCompanyId" placeholder="请选择公司" filterable @change="onChangeCompanyId">
										<el-option key="" label="请选择公司" value=""></el-option>
										<el-option v-for="item in channelsKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="含税订单" v-if="companyConfig.showNoTax">
									<el-switch v-model="form.taxIncluded"></el-switch>
								</el-form-item>
							</el-col>
							<el-col :span="6" v-if="this.orderWarning != ''" style="margin-top:10px">
								<font color=red>{{this.orderWarning}}</font>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="经办人" prop="operator">
									<el-input v-model="form.operator"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="电话" prop="tel">
									<el-input v-model="form.tel"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="支付方式" prop="payType">
									<el-select v-model="form.payType" placeholder="请选择支付类型">
										<el-option key="" label="请选择支付类型" value=""></el-option>
										<el-option :key="0" label="实时支付" :value="0"></el-option>
										<el-option :key="1" label="快递代收" :value="1"></el-option>
										<el-option :key="2" label="账期付款" :value="2"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="合同编号" prop="contractNo">
									<el-input v-model="form.contractNo"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24">
								<el-form-item label="备注" prop="remark">
									<el-input type=textarea :rows=3 v-model="form.remark"> </el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="订单内容" name="detailTab">
					<el-form ref="detail" :model="detail" label-width="50px" :rules="detailRules">
						<el-row>
							<el-col :span="7">
								<el-form-item label="产品" prop="productInfo">
									<el-cascader
										:options="productOptions"
										v-model="detail.productInfo" @change="productChange" filterable clearable>
									</el-cascader>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="数量" prop="num" style="float:left">
									<el-input v-model="detail.num" style="width:80px;"></el-input>&nbsp;
								</el-form-item>
								<el-form-item prop="unit" label-width="0px" style="float:left">
									<el-select v-model="detail.unit" placeholder="单位" style="width:80px;">
										<el-option key="" label="单位" value=""></el-option>
										<el-option v-for="item in unitKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="单价" prop="price">
									<el-input v-model="detail.price"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5" style="padding-left:10px;padding-top:6px">
								<span v-if="currentProductStock"><font color="red">{{currentProductStock}}</font></span>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="20">
								<el-form-item label="备注" prop="remark">
									<el-input type=textarea :rows=3 v-model="detail.remark"> </el-input>
								</el-form-item>
							</el-col>
							<el-col :span="4" align = "center">
								<el-button type="primary" @click="addDetail" style="margin-top:35px">添加</el-button>
							</el-col>
						</el-row>
					</el-form>
					<el-row>
						<el-col :span="24">
							<el-table
								:data="orderDetails"
								border
								class="table"
								header-cell-class-name="table-header"
								:cell-style="{padding:1+'px'}"
								stripe
							>
								<el-table-column prop="id" label="序号" width="50">
									<template slot-scope="scope">
										{{scope.$index + 1}}
									</template>
								</el-table-column>
								<el-table-column prop="seriesName" label="名称" width="200"></el-table-column>
								<el-table-column prop="productName" label="型号" width="150"></el-table-column>
								<el-table-column prop="num" label="数量" width="90">
									<template slot-scope="scope">
										<el-input
										  v-if="scope.row.edit"
										  v-model="scope.row.num"
										  placeholder="数量"
										  @change="handleInputChange(scope.row)"
										></el-input>
										<span v-else>{{ scope.row.num }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="unit" label="单位" width="50" :formatter="unitFormat"></el-table-column>
								<el-table-column prop="price" label="单价" width="90">
									<template slot-scope="scope">
										<el-input
										  v-if="scope.row.edit"
										  v-model="scope.row.price"
										  placeholder="单价"
										  @change="handleInputChange(scope.row)"
										></el-input>
										<span v-else>￥{{ scope.row.price }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="amount" label="金额" width="100"><template slot-scope="scope">￥{{scope.row.amount}}</template></el-table-column>
								<el-table-column prop="remark" label="备注"></el-table-column>
								<el-table-column label="操作" width="120" align="center">
									<template slot-scope="scope">
										<el-button
											type="text"
											icon="el-icon-edit"
											v-if="scope.row.edit==undefined||scope.row.edit==false"
											@click="handleRowEdit(scope.$index, scope.row)"
										>编辑</el-button>
										<el-button
											type="text"
											icon="el-icon-check"
											v-if="scope.row.edit"
											@click="handleRowSave(scope.$index, scope.row)"
										>保存</el-button>
										<el-button
											type="text"
											icon="el-icon-close"
											v-if="scope.row.edit"
											@click="handleRowCancel(scope.$index, scope.row)"
										>取消</el-button>
										<el-button
											type="text"
											icon="el-icon-delete"
											class="red"
											v-if="scope.row.edit==undefined||scope.row.edit==false"
											@click="removeDetail(scope.$index, scope.row)"
										>删除</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</el-tab-pane>
			</el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelEdit">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="订单信息" :visible.sync="showVisible" width="70%">
			<el-form ref="show" :model="show" label-width="100px">
				<el-descriptions class="margin-top" title="" :column="3" size="medium" border>
					<el-descriptions-item>
						<template slot="label">
							供方
						</template>
						{{show.orderCompanyName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							经办人
						</template>
						{{show.operator}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							电话
						</template>
						{{show.tel}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							订单时间
						</template>
						{{show.createTime}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							合同编号
						</template>
						{{show.contractNo}}
						<a style="margin-left:10px;" :href= "imgPrefix + show.contractFile" target="_blank" v-if="show.contractFile">查看合同</a>
						<a style="margin-left:10px;" :href= "imgPrefix + show.countersignFile" target="_blank" v-if="show.countersignFile">查看回签</a>
						<el-link style="margin-left:10px;" type="primary" @click="countersignVisible=true" v-if="!show.countersignFile">上传回签文件</el-link>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							备注
						</template>
						{{show.remark}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							订单数量
						</template>
						{{show.total}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							订单金额
						</template>
						￥{{show.amount}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							状态
						</template>
						{{statusFormat(null, null, show.status)}}
					</el-descriptions-item>
					<el-descriptions-item v-if="show.status<6">
						<template slot="label">
							支付方式
						</template>
						<el-tag :type= "(show.payReceipt > '' || show.balancePayment > 0)?'success':((show.payType===2 && new Date(show.payTime).getTime() < new Date().getTime())?'danger':'warning')" >{{payTypeFormat(null, null, show.payType)}}
						</el-tag>
					</el-descriptions-item>
					<el-descriptions-item v-if="show.status<6 && show.payType===2 && !show.payReceipt">
						<template slot="label">
							账期日期
						</template>
						{{show.payTime}}
					</el-descriptions-item>
					<el-descriptions-item v-if="show.status<6 && show.balancePayment>0">
						<template slot="label">
							余额支付
						</template>
						￥{{show.balancePayment}}
					</el-descriptions-item>
					<el-descriptions-item v-if = "show.status<6 && show.payReceipt">
						<template slot="label">
							现金支付
						</template>
						<el-tooltip content="点击图片放大" placement="right" v-for = "payReceiptItem in show.payReceipt.split(',')" :key="index">
							<div style="float:left">
								<el-image
									class="table-td-thumb"
									:src="imgPrefix+payReceiptItem"
									:preview-src-list="[imgPrefix+payReceiptItem]"
								></el-image>
							</div>
						</el-tooltip>
					</el-descriptions-item>
					<el-descriptions-item v-if = "show.status<6">
						<template slot="label">
							冲账确认
						</template>
						{{show.payConfirmId > 0?show.payConfirmName:"待确认"}}
					</el-descriptions-item>
					<el-descriptions-item v-if="show.payConfirmId > 0 && show.status<6">
						<template slot="label">
							冲账时间
						</template>
						{{show.payConfirmTime}}
					</el-descriptions-item>
					<el-descriptions-item v-if="show.payConfirmId > 0 && show.status<6">
						<template slot="label">
							冲账说明
						</template>
						{{show.payConfirmRemark}}
					</el-descriptions-item>
					<el-descriptions-item v-if="show.status<6">
						<template slot="label">
							到货状态
						</template>
						{{arrivalStatusFormat(null, null, show.arrivalStatus)}}
					</el-descriptions-item>
					<el-descriptions-item v-if="show.status<6">
						<template slot="label">
							是否开票
						</template>
						{{show.invoiceStatus?'已开票':'未开票'}} 
					</el-descriptions-item>
					<el-descriptions-item v-if="show.status<6">
						<template slot="label">
							票据编号
						</template>
						{{show.invoiceNo}} 
					</el-descriptions-item>
				</el-descriptions>
				<el-row style="margin-top:20px">
					<el-col :span="24">
						<el-table
							:data="orderShowDetails"
							border
							class="table"
							header-cell-class-name="table-header"
							:cell-style="{padding:1+'px'}"
							stripe
						>
							<el-table-column prop="id" label="序号" width="50">
								<template slot-scope="scope">
									{{scope.$index + 1}}
								</template>
							</el-table-column>
							<el-table-column prop="seriesName" label="名称" width="200"></el-table-column>
							<el-table-column prop="productName" label="型号" width="150"></el-table-column>
							<el-table-column prop="num" label="数量" width="60"></el-table-column>
							<el-table-column prop="unit" label="单位" width="50" :formatter="unitFormat"></el-table-column>
							<el-table-column prop="price" label="单价" width="70"><template slot-scope="scope">￥{{scope.row.price}}</template></el-table-column>
							<el-table-column prop="amount" label="金额" width="90"><template slot-scope="scope">￥{{scope.row.amount}}</template></el-table-column>
							<el-table-column prop="remark" label="备注"></el-table-column>
							<el-table-column prop="arrivalStatus" label="到货状态" width="80">
							<template slot-scope="scope">{{scope.row.productName==="运费"||scope.row.productName==="维修费"?"--":arrivalStatusFormat(null, null, scope.row.arrivalStatus)}}</template>
							</el-table-column>
							<el-table-column prop="arrivalTime" label="到货时间" width="155">
							<template slot-scope="scope">{{scope.row.productName==="运费"||scope.row.productName==="维修费"?"--":scope.row.arrivalTime}}</template>
							</el-table-column>
							<el-table-column prop="stockId" label="库存编号" width="80">
							<template slot-scope="scope">{{scope.row.productName==="运费"||scope.row.productName==="维修费"?"--":scope.row.stockId}}</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer" v-if = "isCheck">
                <el-button @click="showVisible = false">取 消</el-button>
                <el-button type="primary" @click="checkOrder" v-prevent-re-click>审核</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="上传回签文件" :visible.sync="countersignVisible" width="35%">
			<el-upload
				class="upload-demo"
				multiple
				:before-upload="beforeUpload"
				:action= "countersignUploadUrl"
				:on-success="countersignUploadSuccess"
				:on-remove="countersignRemove"
				:file-list="countersignFileList"
				accept=".png,.jpg,.pdf"
				list-type="picture">
				<el-button size="small" type="primary">点击上传</el-button>
				<div slot="tip" class="el-upload__tip">只能上传jpg/png/pdf文件，且不超过1M</div>
			</el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button @click="countersignVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveCountersignForm" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="支付信息" :visible.sync="paidVisible" width="35%">
			<el-form ref="paid" :model="paid" label-width="100px">
				<el-form-item label="订单号: " >
					{{paid.orderNo}}
				</el-form-item>
				<el-form-item label="供货公司: " >
					{{paid.orderCompanyName}}
				</el-form-item>
				<el-form-item label="挂账余额: " >
					￥{{accountBalance}}
				</el-form-item>
				<el-form-item label="订单数量: " >
					{{paid.total}}
				</el-form-item>
				<el-form-item label="订单金额: " >
					￥{{paid.amount}}
				</el-form-item>
				<el-form-item label="挂账余额支付: " prop="balancePayment" v-if="accountBalance > 0">
					<el-input v-model="paid.balancePayment"></el-input>
				</el-form-item>
				<el-form-item label="支付回单" prop="payReceipt">
					<el-upload
						class="upload-demo"
						multiple
						:before-upload="beforeUpload"
						:action= "uploadUrl"
						:on-success="uploadSuccess"
						:on-remove="handleRemove"
						:file-list="fileList"
						accept=".png,.jpg"
						list-type="picture">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1M</div>
					</el-upload>
				</el-form-item>
			</el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="paidVisible = false">取 消</el-button>
                <el-button type="primary" @click="paidOrder" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="到货" :visible.sync="stockVisible" width="80%">
			<el-form ref="stock" :model="stock" label-width="100px">
				<el-row>
					<el-col :span= "8">
						<el-form-item label="供货公司: " >
							{{stock.orderCompanyName}}
						</el-form-item>
					</el-col>
					<el-col :span = "8">
						<el-form-item label="经办人: " >
							{{stock.operator}}
						</el-form-item>
					</el-col>
					<el-col :span = "8">
						<el-form-item label="电话: " >
							{{stock.tel}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span = "8">
						<el-form-item label="订单号: " >
							{{stock.orderNo}}
						</el-form-item>
					</el-col>
					<el-col :span = "8">
						<el-form-item label="订单数量: " >
							{{stock.total}}
						</el-form-item>
					</el-col>
					<el-col :span = "8">
						<el-form-item label="订单金额: " >
							￥{{stock.amount}}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<el-table
				:data="orderDetailsIntoStock"
				border
				class="table"
				header-cell-class-name="table-header"
				:cell-style="{padding:1+'px'}"
                @selection-change="handleSelectionChange"
				stripe
			>
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="no" label="序号" width="50">
					<template slot-scope="scope">
						{{scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column prop="seriesName" label="名称" width="200"></el-table-column>
				<el-table-column prop="productName" label="型号" width="150"></el-table-column>
				<el-table-column prop="num" label="数量" width="55"></el-table-column>
				<el-table-column prop="unit" label="单位" width="50" :formatter="unitFormat"></el-table-column>
				<el-table-column prop="price" label="单价" width="70"><template slot-scope="scope">￥{{scope.row.price}}</template></el-table-column>
				<el-table-column prop="amount" label="金额" width="90"><template slot-scope="scope">￥{{scope.row.amount}}</template></el-table-column>
				<el-table-column prop="remark" label="备注"></el-table-column>
				<el-table-column prop="arrivalStatus" label="到货状态" width="80">
				<template slot-scope="scope">{{scope.row.productName==="运费"||scope.row.productName==="维修费"?"--":arrivalStatusFormat(null, null, scope.row.arrivalStatus)}}</template></el-table-column>
				<el-table-column prop="arrivalTime" label="到货时间" width="155">
				<template slot-scope="scope">{{scope.row.productName==="运费"||scope.row.productName==="维修费"?"--":scope.row.arrivalTime}}</template></el-table-column>
				<el-table-column prop="stockId" label="库存编号" width="80">
				<template slot-scope="scope">{{scope.row.productName==="运费"||scope.row.productName==="维修费"?"--":scope.row.stockId}}</template></el-table-column>
				<el-table-column label="操作" width="70" align="center">
					<template slot-scope="scope">
						<el-button
							type="text"
							icon="el-icon-sold-out"
							class="red"
							@click="signleIntoStock(scope.$index, scope.row)"
							v-if="controll['arrival'] && scope.row.arrivalStatus === 0"
							v-prevent-re-click
						>入库</el-button>
					</template>
				</el-table-column>
			</el-table>
            <div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="batchIntoStock"
					v-if="controll['arrival']"
					v-prevent-re-click
                >批量入库</el-button>
			</div>
			<span slot="footer" class="dialog-footer">
                <el-button @click="stockVisible = false">取 消</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="收票" :visible.sync="invoiceVisible" width="40%">
			<el-form ref="invoice" :model="invoice" label-width="100px" :rules="invoiceRules">
				<el-form-item label="订单号: " >
					{{invoice.orderNo}}
				</el-form-item>
				<el-form-item label="供货公司: " >
					{{invoice.orderCompanyName}}
				</el-form-item>
				<el-form-item label="订单数量: " >
					{{invoice.total}}
				</el-form-item>
				<el-form-item label="订单金额: " >
					￥{{invoice.amount}}
				</el-form-item>
				<el-form-item label="专票编号: " >
					<el-input v-model="invoice.invoiceNo"></el-input>
				</el-form-item>
			</el-form>	
			<span slot="footer" class="dialog-footer">
                <el-button @click="invoiceVisible = false">取 消</el-button>
				<el-button type="primary" @click="updateOrderInvoice" style="margin-top:35px" v-prevent-re-click>确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import bus from '../../common/bus';
import { getControll } from '../../../utils/controlls';
import { isDecimal, isInt } from '../../../utils/common';
import { fetchPurchaseData, purchase, deleteOrder, getOrder, getChannelKV, getAllProducts, getChannel, 
getEnumValueKV, check, intoStock, updatePaidInfo, audit, updateInvoiceInfo, removeImg, orderCancel, 
getOwnCompany, fetchOrderWarningData, saveCountersignFile, getLatelyPriceAndStock, 
getProductDeficiencyStatus } from '../../../api/index';
import { getAccessToken, callOcrApi, callDocumentApi, getImageAsBase64FromRemoteUrl, 
getDataBase64ByFile, loadContractData } from '@/utils/ocrService';
import { convertChineseCurrencyToNumber } from '../../../utils/chineseRMBConverterUtils';
import axios from 'axios';
import Big from 'big.js'
export default {
    name: 'purchase-order',
    data() {
		let checkProductId = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请选择产品'));
			} else {
				if (value[2] === "") {
					callback(new Error('请选择产品'));
				} else {
					callback();
				}
			}
		}
		
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			rules: {
                orderCompanyId: [{ required: true, message: '企业名称不能为空', trigger: 'blur' }],
				operator: [{ required: true, message: '经办人不能为空', trigger: 'blur' }],
				tel: [{ required: true, message: '联系方式不能为空', trigger: 'blur' }],
				payType: [{required: true, message: '请选择支付方式', trigger: 'blur' }]
            },
			detailRules: {
                productInfo: [{ required: true, validator:checkProductId, trigger: 'blur' }],
				num: [{ required: true, message: '数量不能为空', trigger: 'blur' }],
				unit: [{ required: true, message: '单位不能为空', trigger: 'blur' }],
				price: [{required: true, message: '单价不能为空', trigger: 'blur' }]
            },
			productOptions:[],
			productIdMapping:{},
			channelsKV:[],
			detail:{},
			unitKV:[],
			unitCode:1012,
			activeName:"baseTab",
			orderDetails:[],
			isCheck:false,
			orderShowDetails:[],
			showVisible:false,
			show:{},
			paidVisible:false,
			paid:{},
			stockSelection: [],
			orderDetailsIntoStock:[],
			stockVisible:false,
			stock:{},
			invoice:{},
			invoiceVisible:false,
			invoiceRules:{
				invoiceNo: [{ required: true, message: '专票编号不能为空', trigger: 'blur' }],
			},
			imgPrefix:"/image",
			uploadUrl : "/image/upload/16",
			fileList:[],
			title:"",
			accountBalance:0,
			companyConfig:{},
			orderWarning:"",
			controll:{},
			contractUploadUrl:"/image/upload-contract/",
			currentContractRemoteFiles:[],
			currentContractFile:null,
			contractFileList:[],
			ocrAccessToken:null,
			loading:null,
			feeReg:/KDF001/g,
			rowBackUp:{},
			countersignFileList:[],
			countersignUploadUrl:"/image/upload/24",
			countersignVisible:false,
			countersignFile:undefined,
			currentProductStock:undefined,
			productDeficiencyData:[],
			productDeficiencyVisible:false
        };
    },
    created() {
		this.controll = getControll("purchase-order");
		let ckey = localStorage.getItem('ms_ckey');
		this.uploadUrl = "/image/upload/" + ckey + "/16";
		this.countersignUploadUrl = "/image/upload/" + ckey + "/24";
		this.contractUploadUrl = "/image/upload-contract/" + ckey;
		bus.$on('purchase-order', msg => {
            for (var key in msg) {
				this.query[key] = msg[key];
			}
			this.getData();
        });
		bus.$on('companyNameChange', msg => {
            this.$set(companyConfig, "fullName", msg);
        });
		this.getCompanyConfig();
		this.getProducts();
		this.getChannels();
		this.getUnits();
        this.getData();
    },
    methods: {
		contractUploadStart(file) {
			if (!this.ocrAccessToken) {
				this.$message.error("ocr识别接口不可用，请查看企业信息中是否配置API KEY, 并刷新页面");
				return false;
			}
			this.orderDetails = [];
			this.form = {};
			this.currentContractFile=null;
			this.currentContractUploadFile = [];
			this.loading = this.$loading({
				lock: true,
				text: '正在解析...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			setTimeout(() => {
				this.loading.close();
			}, 15000);
		},
		contractUploadSuccess(response, file, fileList) {
			this.currentContractFile = response.data.url;
			let result = null;
			if (response.data.pdf) {
				if (response.data.document) {
					loadContractData(response.data, this.companyConfig["fullName"], this.channelsKV, 
						this.productIdMapping, this.buildDetailItem, this.form, this.onChangeCompanyId);
					if (this.loading) {
						this.loading.close();
					}
					this.activeName = "baseTab";
					this.editVisible = true;
				} else {
					if (response.data.imgs) {
						for (var i in response.data.imgs) {
							this.currentContractRemoteFiles.push(response.data.imgs[i]);
							getImageAsBase64FromRemoteUrl(this.ocrAccessToken, 
							"/image" + response.data.imgs[i], this.matchData);
						}
					}
				}
			} else {
				getDataBase64ByFile(this.ocrAccessToken, file.raw, this.matchData);
			}
		},
		
		async loginOcrApi(companyConfig) {
			if (companyConfig.ocrApiId == 0) {
				if (!(companyConfig.ocrApiAk && companyConfig.ocrApiSecret)) {
					return;
				}
				this.ocrAccessToken = await getAccessToken(companyConfig.ocrApiAk, 
				companyConfig.ocrApiSecret);
				
			}
		},
		
		matchData(data) {
			let result = {};
			let companys = data.match(/(?<companyName>[\u4E00-\u9FA5（）\(\)]*有限[责任]*公司)/g);
			if (companys) {
				for (var i = companys.length - 1; i > -1; i--) {
					if (companys[i].includes("银行")) {
						companys.splice(i, 1);
					}
				}
				
				if (companys) {
					result["companyNames"] = Array.from(new Set(companys));
				}			
				let regex = /(?<model>([A-Za-z]{1}[a-zA-Z-]*[a-zA-Z0-9\(\)（）<>-]*[\(<（国产\)）>]*|运费))[ \r\n]{1,}(PCS|[\u4E00-\u9FA5]*|)[ \r\n]*(?<num>[0-9]*)[ \r\n]{1,}(PCS|[\u4E00-\u9FA5]*|)[ \r\n]*(?<p1>[0-9.,￥]*)[ \r\n]*(?<p2>[0-9.,￥]*)[ \r\n]*(?<p3>[0-9.,￥]*)[ \r\n]*(?<p4>[0-9.,￥]*)/g;
				let match = {};
				let list = [];
				while ((match = regex.exec(data)) !== null) {
					let node = match.groups;
					if (!("model" in node && "num" in node && "p1" in node && "p2" in node)) {
						continue;
					}
					if (node["model"] == "" || node["num"] == "" || node["p1"] == "" || node["p2"] == "") {
						continue;
					}
					let item = {};
					item["model"] = node["model"].replace(this.feeReg, "运费");
					item["num"] = node["num"];
					let p1 = node["p1"].replace("￥", ",").replace(",", "").replace("，", "");
					let p2 = node["p2"].replace("￥", ",").replace(",", "").replace("，", "");
					let p3 = ("p3" in node)?node["p3"].replace("￥", ",").replace(",", "").replace("，", ""):"";
					let p4 = ("p4" in node)?node["p4"].replace("￥", ",").replace(",", "").replace("，", ""):"";
					let total = (new Big(item["num"])).times(new Big(p1));
					if (total.eq(new Big(p2))|| (p3 != "" && total.eq(new Big(p3))) || 
						(p4 != "" && total.eq(new Big(p4)))) {
						item["price"] = p1;
						list.push(item);
						continue;
					}
					total = (new Big(item["num"])).times(new Big(p2));
					if ((p3 != ""  && total.eq(new Big(p3))) || (p4 != ""  && total.eq(new Big(p4)))) {
						item["price"] = p2;
						list.push(item);
						continue;
					}
					if (p3 != "") {
						total = (new Big(item["num"])).times(new Big(p3));
						if (p4 != ""  && total.eq(new Big(p4))) {
							item.put("price", p3);
							list.add(item);
							continue;
						}
					}
				}
				result["details"] = list;
				let chinesePrice = data.match(/(?<chinesePrice>[零壹贰叁肆伍陆柒捌玖圆元拾佰仟万亿角分厘整]{3,})/g);
				if (chinesePrice) {
					result["total"] = convertChineseCurrencyToNumber(chinesePrice[0]);
				}
			} else {
				this.$message.error("导入合同格式错误");
				if (this.loading) {
					this.loading.close();
				}
				return;
			}
			
			loadContractData(result, this.companyConfig["fullName"], this.channelsKV, 
				this.productIdMapping, this.buildDetailItem, this.form, this.onChangeCompanyId);
			if (this.loading) {
				this.loading.close();
			}
			this.activeName = "baseTab";
			this.editVisible = true;
		},
		getCompanyConfig() {
			getOwnCompany().then(res => {
				if (res.code == 0) {
					this.companyConfig = res.data.applyCompanyConfig;
					this.loginOcrApi(this.companyConfig);
				} else {
					this.$message.error(`获取配置信息失败！` + res.message);
				}
			});
		},
		payTypeFormat(row, column, cellValue) {
			let payTypeConfig = {"0":"款到发货", "1":"快递代收", "2":"账期付款"};
			return payTypeConfig[cellValue];
		},
		arrivalStatusFormat(row, column, cellValue) {
			let arrivalStatusConfig = {"0":"未到货", "1":"部分到货", "2":"全部到货", "3":"撤销"};
			return arrivalStatusConfig[cellValue];
		},
		statusFormat(row, column, cellValue) {
			let statusConfig = {"0":"待审核","1":"待付款","2":"待收货","3":"收货中","4":"已到货","5":"已完结","6":"已撤销"};
			return statusConfig[cellValue];
		},
		unitFormat(row, column, cellValue){
			let index = this.unitKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.unitKV[index].value;
		},
		getChildrenLabel(children, index, names, productInfo) {
			for (var i = 0; i < children.length; i++) {
				if (children[i].value === productInfo[index]) {
					names.push(children[i].label);
					if (null != children[i].children) {
						index ++;
						return this.getChildrenLabel(children[i].children, index, names, productInfo);
					}
				}
			}
		},
		//添加详情
		addDetail() {
			this.$refs.detail.validate(valid => {
				if (valid) {
					this.buildDetailItem(this.detail);
					this.detail = {};
				} else {
					this.$message.error(`订单详情数据不完整！`);
				}
			})
		},
		buildDetailItem(detail) {
			let orderDetail = {};
			orderDetail["typeId"] = detail["productInfo"][0];
			orderDetail["seriesId"] = detail["productInfo"][1];
			orderDetail["productId"] = detail["productInfo"][2];
			let names = [];
			this.getChildrenLabel(this.productOptions, 0, names, detail["productInfo"]);
			//系列名称填充商品类型名称
			orderDetail["seriesName"] = names[0];
			orderDetail["productName"] = names[2];
			orderDetail["num"] = detail["num"];
			orderDetail["unit"] = this.unitFormat(null, null, detail["unit"]);
			orderDetail["price"] = detail["price"];
			orderDetail["amount"] = (detail["num"] * detail["price"]).toFixed(2);
			orderDetail["remark"] = detail["remark"];
			this.orderDetails.push(orderDetail);
		},
		//删除详情
		removeDetail(index, row) {
			this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					let index = this.orderDetails.findIndex(item => {
						if (item.productId === row.productId && item.num === row.num 
						&& item.price === row.price && item.remark === row.remark) {
							return true;
						}
					});
					this.orderDetails.splice(index, 1);
                })
                .catch(() => {});
		},
		//公司变更
		onChangeCompanyId(value) {
			if (typeof(value) === "undefined" || value === "" ) {
				this.$set(this.form, "operator", "");
				this.$set(this.form, "tel", "");
				return;
			}
			getChannel(value).then(res => {
				if (res.code == 0) {
					this.$set(this.form, "operator", res.data.contact);
					this.$set(this.form, "tel", res.data.tel);
				} else {
					this.$message.error(`获取联系人信息失败！` + res.message);
				}
			});
			let condition = {};
			condition["orderType"] = 0;
			condition["orderCompanyId"] = value;
			fetchOrderWarningData(condition).then(res=>{
				if (res.code == 0) {
					let size = res.data.records.length;
					if (size > 0) {
						this.orderWarning = "* 注意：公司存在订单预警信息" + size + "条";
					}
				} else {
					this.$message.error(`获取订单预警信息失败！` + res.message);
				}
			});
		},
		handleProductChange(value) {
			this.productInfo = value;
		},
		//获取产品信息
		getProducts() {
			getAllProducts(this.form).then(res => {
				if (res.code == 0) {
					this.productOptions = res.data;
					this.buildProductIdMapping(this.productOptions, "");
				} else {
					this.$message.error(`获取产品信息失败！` + res.message);
				}
			})
		},
		buildProductIdMapping(options, parentIds){
			for (var index in options) {
				let option = options[index];
				let ids = parentIds?(parentIds + "," + option.value):option.value;
				if (option.children && option.children.length > 0) {
					this.buildProductIdMapping(option.children, ids);
				} else {
					if (ids) {
						this.productIdMapping[option.label] = ids;
					}
				}
			}
		},
		//获取产品信息
		getUnits() {
			getEnumValueKV(this.unitCode).then(res => {
				if (res.code == 0) {
					this.unitKV = res.data;
				} else {
					this.$message.error(`获取单位信息失败！` + res.message);
				}
			})
		},
		//获取渠道
		getChannels() {
			getChannelKV().then(res => {
				if (res.code == 0) {
					this.channelsKV = res.data;
				} else {
					this.$message.error(`获取渠道信息失败！` + res.message);
				}
			});
		},
        // 获取采购订单数据
        getData() {
			if (this.query.invoiceStatus == "null") {
				this.query.taxIncluded = false;
			} else {
				delete this.query["taxIncluded"];
			}
            fetchPurchaseData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        //撤销订单
		hanleCancel(index, row) {
            // 二次确认撤销
            this.$confirm('确定要撤销此订单吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					orderCancel(row.id).then(res => {
						if (res.code == 0) {
							this.$message.success('撤销成功');
							this.getData();
						} else {
							this.$message.error(`撤销失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		handlePaid(index, row) {
			this.paid = row;
			this.paidVisible = true;
			this.fileList = [];
			this.$set(this.paid, 'payReceipt', "");
			this.$set(this.paid, 'balancePayment', 0);
			getChannel(row.orderCompanyId).then(res => {
				if (res.code == 0) {
					this.accountBalance = res.data.accountBalance;
				} else {
					this.$message.error(`获取渠道挂账信息失败！` + res.message);
				}
			});
		},
		paidOrder(){
			if (this.paid.balancePayment > this.paid.amount ) {
				this.$message.error("请输入正确的余额支付金额，不得超过订单金额！");
				return;
			}
			if (this.paid.balancePayment > this.accountBalance ) {
				this.$message.error("渠道挂账余额不足！");
				return;
			}
			if (this.paid.balancePayment < this.paid.amount && (this.paid.payReceipt === "" || typeof(this.paid.payReceipt) == "undefined")) {
				this.$message.error("支付回单不能为空！");
				return;
			}
			let cashPay = this.paid.amount - this.paid.balancePayment;
			this.$confirm('订单金额：' + this.paid.amount + '，挂账余额支付：' + this.paid.balancePayment + '，现金支付：' + cashPay + '，确定支付信息无误？', '提示', {
                type: 'warning'
            })
			.then(() => {
					updatePaidInfo(this.paid).then(res => { 
						if (res.code == 0 ) {
							this.$message.success('支付信息保存成功');
							this.paidVisible = false;
							this.getData();
						} else {
							this.$message.error("支付信息保存失败！" + res.message);
						}
					});
                })
                .catch(() => {}
			);
		},
		//文件上传
		uploadSuccess(response, file, fileList) {
			this.paid.payReceipt = this.paid.payReceipt + (this.paid.payReceipt==""?"":",") + response.data;
		},
		//删除图片
		handleRemove(file, fileList) {
			let fileName = file.response.data;
			removeImg([fileName]).then(res => {
				if (res.code == 0 ) {
					let files = this.paid.payReceipt.split(",");
					let index = files.findIndex(item => {
						if (item === fileName) {
							return true;
						}
					});
					files.splice(index,1);
					this.paid.payReceipt = files.join(",");
					this.$message.success("删除图片成功");
				} else {
					this.$message.error("删除图片失败！" + res.message);
				}
			});
		},
		//文件上传
		countersignUploadSuccess(response, file, fileList) {
			this.countersignFile = response.data;
		},
		//删除图片
		countersignRemove(file, fileList) {
			let fileName = file.response.data;
			removeImg([fileName]).then(res => {
				if (res.code == 0 ) {
					this.countersignFile = undefined;
					this.$message.success("回签文件删除成功");
				} else {
					this.$message.error("回签文件删除失败！" + res.message);
				}
			});
		},
		saveCountersignForm() {
			if (!this.countersignFile) {
				this.$message.error("回签文件不能为空！");
				return;
			}
			this.$set(this.show, "countersignFile", this.countersignFile);
			saveCountersignFile(this.show).then(res => {
				if (res.code == 0) {
					this.$message.success('保存成功！');
					this.countersignVisible = false;
				} else {
					this.$message.error(`保存失败！` + res.message);
				}
			})
		},
		//添加操作
		handleAdd() {
			this.form = {taxIncluded:true};
			this.orderDetails = [];
			this.orderWarning = "";
			this.title = "添加新纪录";
			this.isDisabled = false;
			this.currentContractRemoteFiles = [];
			this.currentContractFile = null;
			this.activeName = "baseTab";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            //this.form = row;
			this.title = "编辑";
			this.orderDetails = [];
			this.isDisabled = true;
			this.getOrderInfo(row, true);
        },
		getOrderInfo(row, isEdit) {
			getOrder(row.id).then(res => {
				if (res.code == 0) {
					if (isEdit) {
						this.$set(this.form, "id", res.data.id);
					}
					this.$set(this.form, "orderCompanyId", res.data.orderCompanyId);
					this.onChangeCompanyId(this.form["orderCompanyId"]);
					this.$set(this.form, "operator", res.data.operator);
					this.$set(this.form, "tel", res.data.tel);
					this.$set(this.form, "remark", res.data.remark);
					this.$set(this.form, "taxIncluded", res.data.taxIncluded);
					this.$set(this.form, "payType", res.data.payType);
					
					for (var i = 0; i < res.data.detailList.length; i++) {
						let orderDetail = {};
						let item = res.data.detailList[i];
						orderDetail["typeId"] = item["typeId"];
						orderDetail["seriesId"] = item["seriesId"];
						orderDetail["productId"] = item["productId"];
						orderDetail["seriesName"] = item["seriesName"];
						orderDetail["productName"] = item["productName"];
						orderDetail["num"] = item["num"];
						orderDetail["unit"] = item["unit"];
						orderDetail["price"] = item["price"];
						orderDetail["amount"] = item["amount"];
						orderDetail["remark"] = item["remark"];
						this.orderDetails.push(orderDetail);
					}
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
		handleShow(index, row) {
			this.isCheck = false;
			this.handleShowDetail(index, row);
		},
		handleCheck(index, row) {
			this.isCheck = true;
			this.handleShowDetail(index, row);
		},
		handleShowDetail(index, row) {
			getOrder(row.id).then(res => {
				if (res.code == 0) {
					this.show = res.data;
					this.orderShowDetails = res.data.detailList;
					this.showVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
		checkOrder() {
			this.$confirm('确定订单无误吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					check(this.show.id).then(res => {
						if (res.code == 0) {
							this.$message.success(`审核成功！`);
							this.showVisible = false;
							this.getData();
						} else {
							this.$message.error(`审核失败！` + res.message);
						}
					});
                })
                .catch(() => {});
		},
		handleSelectionChange(val) {
            this.stockSelection = val;
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					if (this.orderDetails.length == 0) {
						this.$message.error("订单没有内容清单");
						return;
					}
					this.form["detailList"] = this.orderDetails;
					let index = this.channelsKV.findIndex(item => {
						if (item.key === this.form["orderCompanyId"]) {
							return true;
						}
					})
					this.$set(this.form, "orderCompanyName", this.channelsKV[index].value);
					if (this.currentContractFile) {
						this.$set(this.form, "contractFile", this.currentContractFile);
					}
					
					let detailTotalMoney = new Big("0");
					let detailTotalNum = 0;
					for (var i = 0; i < this.orderDetails.length; i++) {
						if (this.orderDetails[i]["edit"]) {
							this.$message.error("有产品项处理编辑状态，请保存或取消修改再操作");
							return;
						}
						detailTotalNum = detailTotalNum + Number(this.orderDetails[i]["num"]);
						detailTotalMoney = detailTotalMoney.plus(new Big(this.orderDetails[i]["amount"]));
					}
						
					if (this.form["totalMoney"] || this.form["itemNum"]) {
						let confirm = detailTotalNum != this.form["itemNum"];
						if (!confirm) {
							confirm = this.form["totalMoney"] && !detailTotalMoney.eq(new Big(this.form["totalMoney"]));
						}
						if (confirm) {
							this.$confirm('订单数量或金额与导入的合同不一致，是否继续保存？', '提示', {
								type: 'warning'
							}).then(() => {
								this.savePurchase(this.form);
							})
							.catch(() => {});
						} else {
							this.savePurchase(this.form);
						}
					} else {
						this.savePurchase(this.form);
					}
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
		savePurchase(form) {
			purchase(form).then(res => {
				if (res.code == 0) {
					this.$message.success('保存成功！');
					this.editVisible = false;
					this.getData();
					if (this.currentContractRemoteFiles.length > 0) {
						removeImg(this.currentContractRemoteFiles);
						this.currentContractRemoteFiles = [];
					}
					this.currentContractFile = null;
				} else {
					this.$message.error(`保存失败！` + res.message);
				}
			})
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		//到货
		hanleArrival(index, row) {
			this.getOrderDetail(index, row.id, false);
		},
		//获取到货操作订单详情
		getOrderDetail(index, id, setTable){
			getOrder(id).then(res => {
				if (res.code == 0) {
					this.stock["orderCompanyName"] = res.data.orderCompanyName;
					this.stock["operator"] = res.data.operator;
					this.stock["tel"] = res.data.tel;
					this.stock["orderNo"] = res.data.orderNo;
					this.stock["total"] = res.data.total;
					this.stock["amount"] = res.data.amount;
					this.stock["id"] = res.data.id;
					this.stock["dataIndex"] = index;
					this.orderDetailsIntoStock = res.data.detailList;
					this.stockVisible = true;
					if (setTable) {
						this.$set(this.tableData, index, res.data);
					}
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
		//入库单项
		signleIntoStock(index, row) {
			let detailStr = "型号：" + row.productName + "，数量：" + row.num + "，单价" + row.price + "，金额：" + row.amount;
			this.orderDetailIntoStock(detailStr, [row.id]);
		},
		//批量入库
		batchIntoStock() {
			const length = this.stockSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
			let ids = [];
			let detailStr = "型号：";
			for (var i = 0; i < this.stockSelection.length; i++) {
				detailStr = detailStr + (i=== 0?"":"，") + this.stockSelection[i].productName;
				ids.push(this.stockSelection[i].id)
			}
			this.orderDetailIntoStock(detailStr, ids);
		},
		//入库操作
		orderDetailIntoStock(detailStr, ids) {
			this.$confirm('确定将 ' + detailStr + ' 产品入库吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					let intoStockData = {};
					intoStockData["id"] = this.stock["id"];
					intoStockData["detailIds"] = ids;
					intoStock(intoStockData).then(res => {
						if (res.code == 0) {
							this.$message.success(`产品入库成功！`);
							this.getOrderDetail(this.stock["dataIndex"], this.stock["id"], true);
							
						} else {
							this.$message.error(`产品入库失败！` + res.message);
						}
					});
                })
                .catch(() => {});
		},
		hanleInvoice(index, row) {
			this.invoice = row;
			this.invoiceVisible = true;
		},
		updateOrderInvoice() {
			let invoiceData = {};
			invoiceData["key"] = this.invoice["id"];
			invoiceData["value"] = this.invoice.invoiceNo;
			updateInvoiceInfo(invoiceData).then(res => {
				if (res.code == 0) {
					this.$message.success(`收票成功！`);
					this.invoiceVisible = false;
					this.getData();
				} else {
					this.$message.error(`收票失败！` + res.message);
				}
			});
		},
		cancelEdit() {
			if (this.currentContractFile) {
				this.currentContractRemoteFiles.push(this.currentContractFile);
			}
			if (this.currentContractRemoteFiles.length > 0) {
				removeImg(this.currentContractRemoteFiles);
				this.currentContractRemoteFiles = [];
			}
			this.currentContractFile = null;
			this.editVisible = false
		},
		beforeUpload(file){
			let limit = file.size / 1024 < 1024;
			if (!limit) {
			  this.$message.error('上传文件大小不能超过 1M');
			  return false;
			}
			return true;
		},
		handleRowEdit(index, row) {
			this.rowBackUp = {};
			for(var item in row) {
				this.rowBackUp[item] = row[item];
			}
			this.$set(row, "edit", true);
		},
		handleRowSave(index, row) {
			let result = isDecimal(row["num"]);
			if (!result.result) {
				this.$message.error("数量" + result.message);
				return;
			}
			result = isDecimal(row["price"]);
			if (!result.result) {
				this.$message.error("单价" + result.message);
				return;
			}
			this.$set(row, "edit", false);
		},
		handleRowCancel(index, row) {
			let isNotChange = true;
			delete row["edit"];
			for(var item in row) {
				isNotChange = this.rowBackUp[item] == row[item];
				if (!isNotChange) {
					break;
				}
			}
			if (isNotChange) {
				this.$set(row, "edit", false);
				return;
			}
			this.$confirm('确定要取消修改吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					for(var item in row) {
						row[item]= this.rowBackUp[item]?this.rowBackUp[item]:"";
					}
					this.$set(row, "edit", false);
                })
                .catch(() => {});
		},
		handleInputChange(row) {
			let result = isDecimal(row["num"]);
			if (!result.result) {
				this.$message.error("数量" + result.message);
				return;
			}
			result = isDecimal(row["price"]);
			if (!result.result) {
				this.$message.error("单价" + result.message);
				return;
			}
			this.$set(row, "amount", ((new Big(row["num"])).times(new Big(row["price"]))).toFixed(2));
		},
		//拷贝订单
		handleCommand(command){
			if (command == "copy") {
				this.orderWarning = "";
				this.title = "添加新纪录";
				this.activeName = "baseTab";
				this.form = {taxIncluded:true};
				this.orderDetails = [];
				this.currentContractRemoteFiles = [];
				this.currentContractFile = null;
				if (this.currentRow==undefined) {
					this.$message.error(`请选择要复制的订单！`);
				}
				this.getOrderInfo(this.currentRow, false);
				this.isDisabled = false;
				this.editVisible = true;
			} else if (command == "add") {
				this.handleAdd();
			}
		},
		handleCurrentChange(val){
			this.currentRow = val;
		},
		productChange(value){
			if (value == "" || value === "" || value === ",,") {
				this.currentProductStock = undefined;
				this.$set(this.detail, "price", "");
				return;
			}
			if (value) {
				let param = {};
				param.productId = value[2];
				param.customerId = this.form["orderCompanyId"];
				param.searchType = 2
				getLatelyPriceAndStock(param).then(res => {
					if (res.code == 0 ) {
						this.currentProductStock = res.data.stock;
					}
				});
			}
		},
		lookupProductDeficiencyStatus() {
			getProductDeficiencyStatus().then(res => {
				if (res.code == 0 ) {
					this.productDeficiencyData = res.data;
					if (this.productDeficiencyData.length == 0) {
						this.$message.info(`没有检索到待订货的产品型号！`);
						return;
					}
					this.productDeficiencyVisible = true;
				} else {
					this.$message.error(`待订货检索失败！` + res.message);
				}
			});
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    width: 40px;
    height: 30px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

.item {
	margin-bottom: 18px;
	border-bottom:1px solid #E0E0E0;
}
</style>
